import { render, staticRenderFns } from "./Log_Service.vue?vue&type=template&id=72237c89&scoped=true&"
import script from "./Log_Service.vue?vue&type=script&lang=js&"
export * from "./Log_Service.vue?vue&type=script&lang=js&"
import style0 from "./Log_Service.vue?vue&type=style&index=0&id=72237c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72237c89",
  null
  
)

export default component.exports